import React, { useState, useRef, useEffect, useContext } from 'react'
import { Player, Queue, Theme, Translator } from '../../components/core'
import { playlist } from '../../hooks/useSpotify'
import { ThemeContext } from 'styled-components';

import "./Settings.css"

export default function Settings(props) {
    // workaround for background issue with musicplayer.
    const themeContext = useContext(ThemeContext);


    // TODO - Refactor the following effects and refs into a hoc
    // useState hook for toggling playlist/queue
    const [queue, setQueue] = useState(false)
    const toggle = () => {
      setQueue(!queue)
    }

    // State
    const [trackIndex, setTrackIndex] = useState(0);
    const [isPlaying, setIsPlaying] = useState(false);
  
    // Destructure for conciseness
    const { title, artist, url } = playlist[trackIndex];
  
    // Refs
    const audioRef = useRef(new Audio(url));
    const intervalRef = useRef();
    const isReady = useRef(false);
  
    const startTimer = () => {
      // Clear any timers already running
      clearInterval(intervalRef.current);

      intervalRef.current = setInterval(() => {
        if (audioRef.current.ended) {
          toNextTrack();
        }
      }, [1000]);
    };
  
    const onStopClick = () => {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setIsPlaying(false);
    };

    const toPrevTrack = () => {
      if (trackIndex - 1 < 0) {
        setTrackIndex(playlist.length - 1);
      } else {
        setTrackIndex(trackIndex - 1);
      }
    };
  
    const toNextTrack = () => {
      if (trackIndex < playlist.length - 1) {
        setTrackIndex(trackIndex + 1);
      } else {
        setTrackIndex(0);
      }
    };

    const queueNext = (e) => {
      setIsPlaying(true);
      setTrackIndex(e);
    }
    
    useEffect(() => {
      if (isPlaying) {
        audioRef.current.play();
        startTimer();
      } else {
        audioRef.current.pause();
      }
    }, [isPlaying]); // eslint-disable-line react-hooks/exhaustive-deps
  
    // Handles cleanup and setup when changing tracks
    useEffect(() => {
      audioRef.current.pause();
  
      audioRef.current = new Audio(url);
      audioRef.current.volume = 0.1;
      if (isReady.current) {
        audioRef.current.play();
        setIsPlaying(true);
        startTimer();
      } else {
        // Set the isReady ref as true for the next pass
        isReady.current = true;
      }
    }, [trackIndex, url]); // eslint-disable-line react-hooks/exhaustive-deps
  
    useEffect(() => {
      // Pause and clean up on unmount
      return () => {
        audioRef.current.pause();
        clearInterval(intervalRef.current);
      };
    }, []);
    
    return (
        <div className="panel container">

          {/* Panel left settings and playlist section */}
          <div className="panel__left">
            <div className="panel__menu">
              <div className="panel__menu_top">
                {/* Theme Switch */}
                <Theme {...props} />

                {/* Music Playlist  */}
                {/* TODO - Add queueNext prop - a functional prop that would play the selected track */}
                <div className="material-icons icon--large z1 mt-2" onClick={toggle}>{ queue ? `arrow_forward`: `queue_music` }</div>
                { queue ? <Queue playlist={playlist} queueNext={queueNext} style={{ display: `${queue} ? 'flex': 'none'`}} /> : null}

              </div>         
              <div className="panel__menu_bottom">
                {/* Translation Dropdown */}
                <Translator />
              </div>
            </div>
          </div>

          {/* Panel right music player */}          
          <div className="panel__right" >
            {/* Music Player */}
            <Player 
              artist={artist}
              title={title}
              isPlaying={isPlaying}
              onPrevClick={toPrevTrack}
              onNextClick={toNextTrack}
              onPlayPauseClick={setIsPlaying}
              onStopClick={onStopClick}
              />
          </div>
          
        
        </div>
    )
}
